import React from 'react';
import ReactDOM from 'react-dom';

import { T } from '../../../../../common/locale/translate';

import HotelNameForm from './HotelNameForm';

export default class HotelNameSearcher extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.initial_value || '',
      pristine: true,
      active: false
    };
  }

  componentDidMount = () => {
    document.addEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  componentWillReceiveProps = nextProps => {
    if (typeof nextProps.hotel_name != 'undefined' && this.state.pristine) {
      this.setState({ value: nextProps.hotel_name, pristine: false });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener(
      'click',
      this.handleClickOutside.bind(this),
      true
    );
  };

  render = () => (
    <div
      className={`hotel-name-searcher-wrapper ${
        this.state.active ? 'active' : ''
      }`}
    >
      <div className="hotel-element-wrapper desktop">
        <label className="hotel-name-searcher-label">
          <span>{T('hotel_name_filter')}:</span>
        </label>
        <input
          type="text"
          value={this.state.value}
          className="hotel-name-searcher-input"
          onFocus={this.handleFocus}
          onChange={this.handleChange}
        />
      </div>
      <div className="hotel-element-wrapper mobile">
        <h3 className="title">{T('hotel_list_title')}</h3>
        <p className="subtitle">{T('hotel_list_subtitle')}</p>
        <span className="hyphen" />
      </div>
      <div className="hotel-name-searcher-submit">
        <div className="hotel-element-wrapper desktop">
          <button onClick={this.handleSearch} className="search-button">
            <i className="fa fa-search" /> {T('look_for')}
          </button>
        </div>
        <div className="hotel-element-wrapper mobile">
          <HotelNameForm
            search={this.handleMobileSearch}
            hotel_name={this.state.value}
          />
        </div>
      </div>
    </div>
  );

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if ((!domNode || !domNode.contains(event.target)) && this.state.active) {
      this.setState({ active: false });
    }
  };

  handleChange = event => this.setState({ value: event.target.value });

  handleFocus = () => {
    this.setState({ active: true });
  };

  handleMobileToggle = () => {
    if (document) {
      document.body.classList.toggle('modal-visible');
      document
        .getElementsByClassName('search-form-outside-wrapper')[0]
        .classList.toggle('active');
    }
  };

  handleMobileSearch = value => {
    this.setState({ value }, () => this.handleSearch());
  };

  handleSearch = () => {
    const url = this.state.value.trim()
      ? `/hotele/szukaj?offer_type=${
          this.props.offer_type
        }&hotel_name=${encodeURIComponent(this.state.value.trim())}`
      : null;

    if (url) {
      window.location.href = url;
    } else {
      alert(`${T('Not redirecting: empty value of')} HotelName`);
    }
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/HotelNameSearcher.jsx